<template>
  <MultiSelector
    v-bind="$attrs"
    :options="options"
    :next-page="nextPage"
    @enable="$emit('enable')"
    @values-updated="onUpdate"
    @fetch-next-page="onBottomOut"
  >
    <template #icon>
      <FilterIcon custom-style="size-4 text-[#707C8ECC]" />
    </template>
  </MultiSelector>
</template>

<script>
export default {
  name: 'AsyncMultiSelector',
  props: {
    fetchFn: {
      type: Function,
      default: (_) => {
        return []
      },
    },
    pageSize: {
      type: Number,
      default: 20,
    },
  },

  emits: ['valuesUpdated', 'enable'],

  data() {
    return {
      loading: false,
      options: [],
      currentPage: 1,
      nextPage: '',
    }
  },
  async mounted() {
    await this.fetchData()
  },
  methods: {
    async fetchData() {
      this.loading = true
      const pagerParams = {
        page: this.currentPage,
        page_size: this.pageSize,
      }
      const resp = await this.fetchFn(pagerParams)
      if (resp.next) {
        this.currentPage++
      }
      this.nextPage = resp.next
      this.options = [...this.options, ...resp.results]
      this.loading = false
    },
    onUpdate(value) {
      this.$emit('valuesUpdated', value)
    },
    async onBottomOut() {
      await this.fetchData()
    },
  },
}
</script>
